// import axios from "axios";
// export default axios.create({

//     baseURL: "https://hapafrica.org/api/v1",
//     // baseURL: "http://localhost:5000/api/v1",
//     headers: {
//         "Content-type": "application/json",
//         "Access-Control-Allow-Origin": "*"
//     }
// })

// import axios from "axios";
// // console.log("API base URL:", window.origin + "/api/v1");
// export default axios.create({
//   // baseURL: window.origin + "/api/v1",
//       baseURL: "http://localhost:5000/api/v1",
//   headers: {
//     "Content-type": "application/json",
//     "Access-Control-Allow-Origin": "*"
//   }
// });

import axios from "axios";

const origin = window.location.origin;
console.log("API base URL:", origin + "/api/v1");

export default axios.create({
  baseURL: origin + "/api/v1",
      // baseURL: "http://localhost:5000/api/v1",
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*", // for browser CORS
    "X-Origin": origin                  // 👈 custom header with frontend origin
  }
});


// import axios from "axios";
// console.log("API base URL:", window.origin + "/api/v1");
// export default axios.create({
//     // baseURL: "window.url/api/v1",
//     // baseURL: "window.url/api/v1",
//     // baseURL: "http://localhost:5000/api/v1",
//     baseURL: "https://smartinvoicing.net/api/v1",

//     headers: {
//         "Content-type": "application/json",
//         "Access-Control-Allow-Origin": "*"
//     }
// })